let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gV7F7")).then(() => parcelRequire('a1RAT'));